export default {
  closeAriaLabel: {
    is: 'Loka glugga',
    en: 'Close window',
    pl: 'Zamknij okno',
  },
};
